import { render, staticRenderFns } from "./TitleMenuComponent.vue?vue&type=template&id=061adb3a"
import script from "./TitleMenuComponent.vue?vue&type=script&lang=js"
export * from "./TitleMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports